module.exports = __webpack_public_path__ + "static/img/s1031.8f14ad09.png";